
import { Vue, Component } from "vue-property-decorator";
import Ace from "@/components/helpers/ace.vue";
import editor from "./editor";
@Component({
  components: { Ace },
  mixins: [editor],
})
export default class AceFormEditor extends Vue {}
